export default "__VITE_ASSET__CkK1vj6Y__"